<ng-container *ngIf="field && form?.value && form.value[field] as fieldValue">
  <div *ngIf="fieldValue | displayResetFilter"
       class="reset-filter"
       (click)="resetFilter()">
    <i [class]="resetFilterIcon || 'fas fa-fw fa-trash-alt'"></i>
  </div>
</ng-container>
